module.exports = __webpack_public_path__ + "img/taipeiarealeft.fdd43757.svg";